module.exports = __webpack_public_path__ + "img/2023_0.b52b2862.webp";